module.exports = __webpack_public_path__ + "img/advantage-4.1cb870cf.svg";